import React, { useEffect, useState } from "react";
import { useRef } from "react";
import {
  Select,
  Tabs,
  Table,
  Card,
  Spin,
  message,
  Modal,
  Button,
} from "antd";
import axios from "axios";
import { BASE_URL } from "../../App";
import "./serviceAudit.css";
import { DatePicker } from "antd";
import dayjs from "dayjs";


const { Option } = Select;

export default function ServiceClaimAuditPage() {
  const [loadingSectors, setLoadingSectors] = useState(true);
  const [sectors, setSectors] = useState([]);
  const [selectedSector, setSelectedSector] = useState(null);
const lastRequestRef = useRef({ sector: null, tab: null });
  const [loadingClaims, setLoadingClaims] = useState(false);
  const [claims, setClaims] = useState([]);

  //const [activeTab, setActiveTab] = useState("UNVERIFIED");
  const [activeTab, setActiveTab] = useState("");

const [selectedRowKeys, setSelectedRowKeys] = useState([]);
const [selectedRows, setSelectedRows] = useState([]);

  const [modalOpen, setModalOpen] = useState(false);
  const [modalRecord, setModalRecord] = useState(null);
const [settledFilter, setSettledFilter] = useState("ALL");

  const [lineItems, setLineItems] = useState([]);
  const [totalReversal, setTotalReversal] = useState(0);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [saving, setSaving] = useState(false);

  const login_id = localStorage.getItem("LOGIN_ID") || "";

  // -----------------------------------------------------
  // LOAD SECTORS
  // -----------------------------------------------------
  useEffect(() => {
    axios
      .post(BASE_URL + "/sectors_audit", { login_id })
      .then((res) => {
        setSectors(res.data.sectors || []);
        setLoadingSectors(false);
      })
      .catch(() => {
        message.error("Unable to load sectors");
        setLoadingSectors(false);
      });
  }, []);
  const filteredSettledClaims = claims.filter((r) => {
  const rev = Number(r.REVERSE_AMOUNT || 0);
  const debit = r.sap_debit_no;

  if (settledFilter === "NO_REVERSAL") {
    return rev === 0;
  }

  if (settledFilter === "PENDING_REVERSAL") {
    return rev > 0 && !debit;
  }

  if (settledFilter === "COMPLETED_REVERSAL") {
    return rev > 0 && debit;
  }

  return true; // ALL
});

const dateRangeFilter = (dataIndex) => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <DatePicker.RangePicker
        value={selectedKeys[0] || null}
        onChange={(dates) => {
          setSelectedKeys(dates ? [dates] : []);
        }}
        style={{ marginBottom: 8, width: "100%" }}
      />

      <div style={{ display: "flex", gap: 8 }}>
        <Button
          size="small"
          type="primary"
          onClick={() => confirm({ closeDropdown: true })}
        >
          Apply
        </Button>
        <Button
          size="small"
          onClick={() => {
            clearFilters();
            setSelectedKeys([]);
            confirm({ closeDropdown: true });
          }}
        >
          Reset
        </Button>
      </div>
    </div>
  ),

  onFilter: (value, record) => {
    if (!value || !record[dataIndex]) return true;

    const recordTime = new Date(record[dataIndex]).setHours(0, 0, 0, 0);
    const startTime = value[0].toDate().setHours(0, 0, 0, 0);
    const endTime = value[1].toDate().setHours(23, 59, 59, 999);

    return recordTime >= startTime && recordTime <= endTime;
  },
});
const submitSettlement = async () => {
  if (selectedRows.length === 0) {
    message.warning("Select at least one claim");
    return;
  }

  const docs = selectedRows.map((r) => r.doc_no);

  try {
    const res = await axios.post(BASE_URL + "/settleclaims", {
      docs,login_id:login_id
    });

    if (res.data.status === "success") {
      message.success("Claims settled successfully");

     const headers = [
  "SCR Number",
  "Service Centre Code",
  "Service Centre Name",
  "Serial Number",
  "Item Description",
  "Claim Value",
  "Claim Date",

  "Reverse CGST",
  "Reverse SGST",
  "Reverse IGST",
 // "Reverse GST",
  "Reverse Actual",
  "Reverse Total",
  "Verified By",
  "Verified On",
  "Settled By",
  "Settled On",
];
const rows = res.data.data.map((r) => [
  r.doc_no,
  r.asc_code,
  r.asc_name,
  r.SERIAL_NO,
  r.item,
  r.CLAIM_AMOUNT,
  r.OLTPS_GJV_DATE?.substring(0, 10),

  // 🔹 Newly added GST columns
  r.REVERSE_CGST,
  r.REVERSE_SGST,
  r.REVERSE_IGST,
 // r.REVERSE_GST,
  r.REVERSE_Actual,
  r.REVERSE_AMOUNT,

  r.VerifiedBy,
  r.VerifiedOn,
  r.SettledBy,
  r.SettledOn,
]);

      let csv = headers.join(",") + "\n";
      rows.forEach((r) => {
        csv += r.map((v) => `"${v ?? ""}"`).join(",") + "\n";
      });

      const blob = new Blob([csv], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "Reversal_Settlement.csv";
      a.click();

      // Remove settled docs from table
      setClaims((prev) =>
        prev.filter((c) => !docs.includes(c.doc_no))
      );

      setSelectedRowKeys([]);
      setSelectedRows([]);
    }
  } catch (err) {
    message.error("Settlement failed");
  }
};
const fetchClaimsByStatus = (sector, status) => {
  setLoadingClaims(true);
  setClaims([]);                // clear immediately
  setSelectedRowKeys([]);
  setSelectedRows([]);

  // ✅ Track this request
  lastRequestRef.current = { sector, status };

  axios
    .post(BASE_URL + "/getclaimsbystatus", {
      sector,
      status,
      login_id,
    })
    .then((res) => {
      // ❗ Ignore outdated responses
      const last = lastRequestRef.current;
      if (last.sector !== sector || last.status !== status) {
        return;
      }

      setClaims(res.data || []);
      setLoadingClaims(false);
    })
    .catch(() => {
      const last = lastRequestRef.current;
      if (last.sector !== sector || last.status !== status) {
        return;
      }

      message.error("Unable to load claims");
      setClaims([]);
      setLoadingClaims(false);
    });
};

//   const fetchUnverifiedClaims = (sector) => {
//     setLoadingClaims(true);
//     axios
//       .post(BASE_URL + "/getunverifiedclaims", { sector })
//       .then((res) => {
//         setClaims(res.data || []);
//         setLoadingClaims(false);
//       })
//       .catch(() => {
//         message.error("Unable to load claims");
//         setLoadingClaims(false);
//       });
//   };
// useEffect(() => {
//   if (activeTab === "SETTLED") {
//     setClaims((prev) =>
//       prev.filter((c) => c.Audit_Status === "SETTLED")
//     );
//   }
// }, [activeTab]);

  const openModal = (rec) => {
    setModalRecord(rec);
    setModalOpen(true);

    // Restore previous entries if exist
    if (rec.TEMP_LINE_ITEMS) {
      setLineItems(rec.TEMP_LINE_ITEMS);

      const sum = rec.TEMP_LINE_ITEMS.reduce(
        (a, r) => a + Number(r.reverse_total || 0),
        0
      );
      setTotalReversal(sum);
    } else {
      loadClaimDetails(rec.doc_no);
    }
  };

  // -----------------------------------------------------
  // LOAD CLAIM DETAILS FROM API
  // -----------------------------------------------------
  // const loadClaimDetails = (doc_no) => {
  //   setLoadingDetails(true);

  //   axios
  //     .post(BASE_URL + "/getclaimdetails", { doc_no })
  //     .then((res) => {
  //       const rows = (res.data || []).map((item, i) => ({
  //         line_no: i + 1,
  //         type: item.LABOURCHARGE_ID ? "LABOUR" : "SPARE",
  //             item_code: item.LABOURCHARGE_ID
  // ? item.LABOURCHARGE_ID.trim()
  // : item.SPARE_CODE
  // ? item.SPARE_CODE.trim()
  // : "-",

  //         item_desc: item.LABOURCHARGE_DESCRIPTION || item.SPARE_NAME,
      
  //         QUANTITY: item.QUANTITY || 1,
  //         RATE: Number(item.RATE || item.LISTRATE || 0),

  //         CGST_PERCENT: Number(item.CGST_PERCENT || 0),
  //         SGST_PERCENT: Number(item.SGST_PERCENT || 0),
  //         IGST_PERCENT: Number(item.IGST_PERCENT || 0),

  //         CGST_VALUE: Number(item.CGST_VALUE || 0),
  //         SGST_VALUE: Number(item.SGST_VALUE || 0),
  //         IGST_VALUE: Number(item.IGST_VALUE || 0),

  //         TOTAL_AMOUNT: Number(item.TOTAL_AMOUNT || 0),

  //         reversal_rate: "",
  //         reverse_cgst: 0,
  //         reverse_sgst: 0,
  //         reverse_igst: 0,
  //         reverse_total: 0,

  //         LABOURCHARGE_ID: item.LABOURCHARGE_ID || null,
  //         SPARE_CODE: item.SPARE_CODE || null,
  //       }));

  //       setLineItems(rows);
  //       setTotalReversal(0);
  //       setLoadingDetails(false);
  //     })
  //     .catch(() => setLoadingDetails(false));
  // };
  const loadClaimDetails = (doc_no) => {
  setLoadingDetails(true);

  axios
    .post(BASE_URL + "/getclaimdetails", { doc_no })
    .then((res) => {
      const rows = (res.data || []).map((item, i) => {
        const reverseRate = Number(item.REVERSE_RATE || 0);
        const reverseCgst = Number(item.REVERSE_CGST_VALUE || 0);
        const reverseSgst = Number(item.REVERSE_SGST_VALUE || 0);
        const reverseIgst = Number(item.REVERSE_IGST_VALUE || 0);
        const reverseTotal = Number(item.REVERSE_TOTAL_AMOUNT || 0);

        return {
          line_no: i + 1,
          type: item.LABOURCHARGE_ID ? "LABOUR" : "SPARE",

          item_code: item.LABOURCHARGE_ID
            ? item.LABOURCHARGE_ID.trim()
            : item.SPARE_CODE
            ? item.SPARE_CODE.trim()
            : "-",

          item_desc:
            item.LABOURCHARGE_DESCRIPTION || item.SPARE_NAME,

          QUANTITY: item.QUANTITY || 1,
          RATE: Number(item.RATE || item.LISTRATE || 0),

          CGST_PERCENT: Number(item.CGST_PERCENT || 0),
          SGST_PERCENT: Number(item.SGST_PERCENT || 0),
          IGST_PERCENT: Number(item.IGST_PERCENT || 0),

          CGST_VALUE: Number(item.CGST_VALUE || 0),
          SGST_VALUE: Number(item.SGST_VALUE || 0),
          IGST_VALUE: Number(item.IGST_VALUE || 0),

          TOTAL_AMOUNT: Number(item.TOTAL_AMOUNT || 0),

          // ✅ LOAD SAVED REVERSAL VALUES (FOR VERIFIED)
          reversal_rate: reverseRate ? reverseRate.toFixed(2) : "",
          reverse_cgst: reverseCgst,
          reverse_sgst: reverseSgst,
          reverse_igst: reverseIgst,
          reverse_total: reverseTotal,

          LABOURCHARGE_ID: item.LABOURCHARGE_ID || null,
          SPARE_CODE: item.SPARE_CODE || null,
        };
      });

      setLineItems(rows);

      // ✅ calculate total reversal from DB
      setTotalReversal(
        rows.reduce((a, r) => a + Number(r.reverse_total || 0), 0)
      );

      setLoadingDetails(false);
    })
    .catch(() => setLoadingDetails(false));
};

const textFilter = (dataIndex) => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <input
        autoFocus
        placeholder="Search"
        value={selectedKeys[0] || ""}
        onChange={(e) => {
          const val = e.target.value;
          setSelectedKeys(val ? [val] : []);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            confirm({ closeDropdown: true });
          }
        }}
        style={{ marginBottom: 8, width: "100%" }}
      />

      <div style={{ display: "flex", gap: 8 }}>
        <Button
          size="small"
          type="primary"
          onClick={() => confirm({ closeDropdown: true })}
        >
          Search
        </Button>

        <Button
          size="small"
          onClick={() => {
            clearFilters();
            setSelectedKeys([]);
            confirm({ closeDropdown: true });
          }}
        >
          Reset
        </Button>
      </div>
    </div>
  ),

  onFilter: (value, record) =>
    record[dataIndex]
      ?.toString()
      .toLowerCase()
      .includes(value.toLowerCase()),
});
const numberFilter = (dataIndex) => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <input
        type="number"
        autoFocus
        placeholder="Enter value"
        value={selectedKeys[0] || ""}
        onChange={(e) => {
          const val = e.target.value;
          setSelectedKeys(val ? [val] : []);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            confirm({ closeDropdown: true });
          }
        }}
        style={{ marginBottom: 8, width: "100%" }}
      />

      <div style={{ display: "flex", gap: 8 }}>
        <Button
          size="small"
          type="primary"
          onClick={() => confirm({ closeDropdown: true })}
        >
          Apply
        </Button>

        <Button
          size="small"
          onClick={() => {
            clearFilters();
            setSelectedKeys([]);
            confirm({ closeDropdown: true });
          }}
        >
          Reset
        </Button>
      </div>
    </div>
  ),

  onFilter: (value, record) =>
    Number(record[dataIndex] || 0) >= Number(value),
});



const settledColumns = [
  {
    title: "SCR",
    dataIndex: "doc_no",
    width: 75,
    ...textFilter("doc_no"),
  },
  {
    title: "ASC Code",
    dataIndex: "asc_code",
    width: 65,
    ...textFilter("asc_code"),
  },
  {
    title: "ASC Name",
    dataIndex: "asc_name",
    width: 100,
    ellipsis: true,
    ...textFilter("asc_name"),
  },
  {
    title: "Serial",
    dataIndex: "SERIAL_NO",
    width: 115,
    ...textFilter("SERIAL_NO"),
  },
  {
    title: "Item",
    dataIndex: "item",
    width: 170,
    ellipsis: true,
    ...textFilter("item"),
  },

  {
    title: "Claim Amt",
    dataIndex: "CLAIM_AMOUNT",
    width: 80,
    ...numberFilter("CLAIM_AMOUNT"),
    render: (v) => `₹ ${Number(v || 0).toFixed(2)}`,
  },

  {
    title: "Reversal",
    dataIndex: "REVERSE_AMOUNT",
    width: 80,
    filters: [
      { text: "No Reversal", value: "0" },
      { text: "Has Reversal", value: "1" },
    ],
    onFilter: (v, r) =>
      v === "0"
        ? Number(r.REVERSE_AMOUNT || 0) === 0
        : Number(r.REVERSE_AMOUNT || 0) > 0,
    render: (v) => `₹ ${Number(v || 0).toFixed(2)}`,
  },

  {
    title: "Debit Note No",
    dataIndex: "sap_debit_no",
    width: 110,
    filters: [
      { text: "Pending", value: "P" },
      { text: "Completed", value: "C" },
    ],
    onFilter: (v, r) =>
      v === "P"
        ? Number(r.REVERSE_AMOUNT || 0) > 0 && !r.sap_debit_no
        : !!r.sap_debit_no,
    render: (v, r) =>
      Number(r.REVERSE_AMOUNT || 0) === 0 ? "No Reversal" : v || "Pending",
  },
];
const getColumnFilters = (data, key) => {
  const uniqueValues = [
    ...new Set(
      data
        .map((r) => r[key])
        .filter((v) => v !== null && v !== undefined && v !== "")
    ),
  ];

  return uniqueValues.map((v) => ({
    text: v,
    value: v,
  }));
};


const downloadSettledExcel = () => {
  const data = filteredSettledClaims;

  if (data.length === 0) {
    message.warning("No data to download");
    return;
  }

  const headers = [
    "SCR Number",
    "Service Centre Code",
    "Service Centre Name",
    "Serial Number",
    "Item Description",
    "Claim Value",
    "Claim Date",    
    "Reversal CGST",
    "Reversal SGST",
    "Reversal IGST",
    "Reversal Actual",
    "Reversal Total",
    "Verified By",
    "Verified On",
    "Settled On",
    "Debit Note No",
  ];
const rows = data.map((r) => {
  const cgst =
    Number(r.REVERSE_LABOUR_CGST || 0) +
    Number(r.REVERSE_SPARE_CGST || 0);

  const sgst =
    Number(r.REVERSE_LABOUR_SGST || 0) +
    Number(r.REVERSE_SPARE_SGST || 0);

  const igst =
    Number(r.REVERSE_LABOUR_IGST || 0) +
    Number(r.REVERSE_SPARE_IGST || 0);

  const actual =
    Number(r.REVERSE_SPARE || 0) +
    Number(r.REVERSE_LABOUR || 0);

  const total = Number(r.REVERSE_AMOUNT || 0);

  return [
    r.doc_no,
    r.asc_code,
    r.asc_name,
    r.SERIAL_NO,
    r.item,
    r.CLAIM_AMOUNT,
    r.OLTPS_GJV_DATE?.substring(0, 10),

    cgst.toFixed(2),
    sgst.toFixed(2),
    igst.toFixed(2),
    actual.toFixed(2),
    total.toFixed(2),

    r.verifiedby,
    r.verifiedon,
    r.Settledon,
    r.sap_debit_no || "",
  ];
});

  let csv = headers.join(",") + "\n";
  rows.forEach((r) => {
    csv += r.map((v) => `"${v ?? ""}"`).join(",") + "\n";
  });

  const blob = new Blob([csv], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = "Settled_Claims.csv";
  a.click();
};

const updateReversalValue = (index, rawVal) => {
  const updated = [...lineItems];
  const item = updated[index]; // ✅ MOVE THIS TO TOP

  // allow only digits and dot
  if (!/^\d*\.?\d*$/.test(rawVal)) return;

  // allow empty
  if (rawVal === "") {
    item.reversal_rate = "";
    item.reverse_cgst = 0;
    item.reverse_sgst = 0;
    item.reverse_igst = 0;
    item.reverse_total = 0;

    setLineItems(updated);
    setTotalReversal(
      updated.reduce((a, r) => a + Number(r.reverse_total || 0), 0)
    );
    return;
  }

  // allow "." or "1."
  const val = parseFloat(rawVal);
  if (isNaN(val)) {
    item.reversal_rate = rawVal;
    setLineItems(updated);
    return;
  }

  const maxRate = Number(item.RATE || 0);
  if (val > maxRate) {
    message.error("Reversal cannot exceed Rate.");
    return;
  }

  const cgst = Number(((val * item.CGST_PERCENT) / 100).toFixed(2));
  const sgst = Number(((val * item.SGST_PERCENT) / 100).toFixed(2));
  const igst = Number(((val * item.IGST_PERCENT) / 100).toFixed(2));
  const total = Number((val + cgst + sgst + igst).toFixed(2));

  item.reversal_rate = rawVal; // ✅ KEEP STRING WHILE TYPING
  item.reverse_cgst = cgst;
  item.reverse_sgst = sgst;
  item.reverse_igst = igst;
  item.reverse_total = total;

  setLineItems(updated);

  // persist
  setClaims((prev) =>
    prev.map((c) =>
      c.doc_no === modalRecord.doc_no
        ? { ...c, TEMP_LINE_ITEMS: updated }
        : c
    )
  );

  setTotalReversal(
    updated.reduce((a, r) => a + Number(r.reverse_total || 0), 0)
  );
};

//   const updateReversalValue = (index, rawVal) => {
//     const updated = [...lineItems];

//     if (rawVal === "" || rawVal === null) {
//       updated[index].reversal_rate = "";
//       updated[index].reverse_cgst = 0;
//       updated[index].reverse_sgst = 0;
//       updated[index].reverse_igst = 0;
//       updated[index].reverse_total = 0;
//     } else {
//     //   const val = Number(String(rawVal).trim());
//     //   if (isNaN(val) || val < 0) return;
//     // allow only numbers and dot
// if (!/^\d*\.?\d*$/.test(rawVal)) return;

// const val = parseFloat(rawVal);

// // allow typing "." or "1."
// if (isNaN(val)) {
//   item.reversal_rate = rawVal;
//   item.reverse_cgst = 0;
//   item.reverse_sgst = 0;
//   item.reverse_igst = 0;
//   item.reverse_total = 0;
//   setLineItems(updated);
//   return;
// }


//       const item = updated[index];
//       const maxRate = Number(item.RATE || 0);

//       if (val > maxRate) {
//         message.error("Reversal cannot exceed Rate.");
//         return;
//       }

//       const cgst = Number(((val * item.CGST_PERCENT) / 100).toFixed(2));
//       const sgst = Number(((val * item.SGST_PERCENT) / 100).toFixed(2));
//       const igst = Number(((val * item.IGST_PERCENT) / 100).toFixed(2));

//       const total = Number((val + cgst + sgst + igst).toFixed(2));

//       item.reversal_rate = val;
//       item.reverse_cgst = cgst;
//       item.reverse_sgst = sgst;
//       item.reverse_igst = igst;
//       item.reverse_total = total;
//     }

//     setLineItems(updated);

//     // Persist to claims[] so reopening modal restores values
//     setClaims((prev) =>
//       prev.map((c) =>
//         c.doc_no === modalRecord.doc_no
//           ? { ...c, TEMP_LINE_ITEMS: updated }
//           : c
//       )
//     );

//     const sum = updated.reduce(
//       (acc, it) => acc + Number(it.reverse_total || 0),
//       0
//     );
//     setTotalReversal(sum);
//   };

  // -----------------------------------------------------
  // VERIFY CLAIM API CALL
  // -----------------------------------------------------
  const verifyClaim = async () => {
    setSaving(true);

    const itemsPayload = lineItems.map((r) => ({
      LABOURCHARGE_ID: r.LABOURCHARGE_ID,
      SPARE_CODE: r.SPARE_CODE,

      REVERSE_RATE: Number(r.reversal_rate || 0),
      REVERSE_CGST_VALUE: Number(r.reverse_cgst || 0),
      REVERSE_SGST_VALUE: Number(r.reverse_sgst || 0),
      REVERSE_IGST_VALUE: Number(r.reverse_igst || 0),
      REVERSE_TOTAL_AMOUNT: Number(r.reverse_total || 0),

      CGST_PERCENT: r.CGST_PERCENT,
      SGST_PERCENT: r.SGST_PERCENT,
      IGST_PERCENT: r.IGST_PERCENT,
    }));

    const payload = {
      doc_no: modalRecord.doc_no,
      totalReversal: Number(totalReversal.toFixed(2)),
      verified_by: login_id,
      items: itemsPayload,
    };

    try {
      const res = await axios.post(BASE_URL + "/verifyclaim", payload);

      if (res.data?.status === "success") {
  const auditStatus = res.data.audit_status;

  if (auditStatus === "SETTLED") {
    message.success("No reversal. Claim settled successfully.");
  } else {
    message.success("Claim verified successfully.");
  }


        // Remove verified claim from list
        setClaims((prev) =>
          prev.filter((c) => c.doc_no !== modalRecord.doc_no)
        );

        setModalOpen(false);
      } else {
        message.error(res.data?.message || "Verification failed");
      }
    } catch (err) {
      message.error("Server error.");
    }

    setSaving(false);
  };

  // -----------------------------------------------------
  // MODAL COLUMNS
  // -----------------------------------------------------
  const modalColumns = [
    { title: "Line", dataIndex: "line_no", width: 50 },
    { title: "Type", dataIndex: "type", width: 80 },
    { title: "CODE", dataIndex: "item_code", width: 80 },
    { title: "Description", dataIndex: "item_desc", width: 220 },
    { title: "Qty", dataIndex: "QUANTITY", width: 60 },

    {
      title: "GST %",
      width: 80,
      render: (r) =>
        (
          Number(r.CGST_PERCENT || 0) +
          Number(r.SGST_PERCENT || 0) +
          Number(r.IGST_PERCENT || 0)
        ).toFixed(2),
    },

    {
      title: "Total(Without GST)",
      dataIndex: "RATE",
      width: 90,
      render: (v) => Number(v).toFixed(2),
    },

    {
      title: "Total(With GST)",
      dataIndex: "TOTAL_AMOUNT",
      width: 100,
      render: (v) => `₹ ${Number(v).toFixed(2)}`,
    },

    {
      title: "Reversal (Without GST)",
      width: 150,
      render: (_, row, idx) => (
        <input
  type="text"
  inputMode="decimal"
  value={row.reversal_rate ?? ""}
  onChange={(e) =>
    activeTab !== "VERIFIED" &&
    updateReversalValue(idx, e.target.value)
  }
  className="compact-input"
  placeholder={
    activeTab === "VERIFIED" ? "" : "Enter reversal"
  }
  disabled={activeTab === "VERIFIED"}
  style={{
    width: "100%",
    padding: 6,
    borderRadius: 4,
    border: "1px solid #ccc",
    backgroundColor:
      activeTab === "VERIFIED" ? "#f5f5f5" : "#fff",
    cursor:
      activeTab === "VERIFIED" ? "not-allowed" : "text",
  }}
/>

        // <input
        //   type="text"
        //   inputMode="decimal"
        //   value={row.reversal_rate ?? ""}
        //   onChange={(e) => updateReversalValue(idx, e.target.value)}
        //   className="compact-input"
        //   placeholder="Enter reversal"
        //   style={{
        //     width: "100%",
        //     padding: 6,
        //     borderRadius: 4,
        //     border: "1px solid #ccc",
        //   }}
        // />
      ),
    },

    {
      title: "Reversal (With GST)",
      width: 140,
      render: (r) => `₹ ${Number(r.reverse_total || 0).toFixed(2)}`,
    },
  ];

const amountRangeFilter = (dataIndex) => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
    const [min = "", max = ""] = selectedKeys[0] || [];

    return (
      <div style={{ padding: 8 }}>
        <input
          type="number"
          placeholder="Min"
          value={min}
          onChange={(e) => {
            const val = e.target.value;
            setSelectedKeys([[val, max]]);
          }}
          style={{ marginBottom: 6, width: "100%" }}
        />

        <input
          type="number"
          placeholder="Max"
          value={max}
          onChange={(e) => {
            const val = e.target.value;
            setSelectedKeys([[min, val]]);
          }}
          style={{ marginBottom: 8, width: "100%" }}
        />

        <div style={{ display: "flex", gap: 8 }}>
          <Button
            size="small"
            type="primary"
            onClick={() => confirm({ closeDropdown: true })}
          >
            Apply
          </Button>
          <Button
            size="small"
            onClick={() => {
              clearFilters();
              setSelectedKeys([]);
              confirm({ closeDropdown: true });
            }}
          >
            Reset
          </Button>
        </div>
      </div>
    );
  },

  onFilter: (value, record) => {
    if (!value) return true;

    const [min, max] = value;
    const amt = Number(record[dataIndex] || 0);

    if (min && amt < Number(min)) return false;
    if (max && amt > Number(max)) return false;

    return true;
  },
});

 const columns = [
  {
  title: "SCR",
  dataIndex: "doc_no",
  width: 90,
  ...textFilter("doc_no"),
  render: (_, rec) =>
    activeTab === "UNVERIFIED" || activeTab === "VERIFIED" ? (
      <a className="compact-link" onClick={() => openModal(rec)}>
        {rec.doc_no}
      </a>
    ) : (
      <span>{rec.doc_no}</span>
    ),
},

  { title: "Call", dataIndex: "SERVICECALL_NO", width: 50 },

  {
    title: "ASC Code",
    dataIndex: "asc_code",
    width: 90,
    ...textFilter("asc_code"),
  },
  {
    title: "ASC Name",
    dataIndex: "asc_name",
    width: 140,
    ...textFilter("asc_name"),
  },
  {
    title: "Serial",
    dataIndex: "SERIAL_NO",
    width: 130,
    ...textFilter("SERIAL_NO"),
  },
  {
    title: "Item",
    dataIndex: "item",
    width: 250,
    ellipsis: true,
    ...textFilter("item"),
  },

 {
  title: "Claim Amt",
  dataIndex: "CLAIM_AMOUNT",
  width: 100,
  ...amountRangeFilter("CLAIM_AMOUNT"),
  render: (v) => `₹ ${Number(v || 0).toFixed(2)}`,
}
,

  {
  title: "GJV Date",
  dataIndex: "OLTPS_GJV_DATE",
  width: 110,
  ...dateRangeFilter("OLTPS_GJV_DATE"),
  render: (v) => (v ? v.substring(0, 10) : ""),
},

 {
  title: "Reversal",
  dataIndex: "REVERSE_AMOUNT",
  width: 100,
  ...amountRangeFilter("REVERSE_AMOUNT"),
  render: (v) => `₹ ${Number(v || 0).toFixed(2)}`,
}
,
];


  return (
    <div className="service-audit-root">
      <Card className="compact-card" bordered={false}>
        <div className="card-row">
          <h3 className="card-title">Select Sector</h3>

          <Select
            size="middle"
            style={{ width: 260 }}
            placeholder="Choose sector"
           onChange={(v) => {
  setSelectedSector(v);
  setActiveTab("UNVERIFIED");
  fetchClaimsByStatus(v, "UNVERIFIED");
}}

          >
            {sectors.map((s) => (
              <Option key={s} value={s}>
                {s}
              </Option>
            ))}
          </Select>
        </div>
      </Card>

   <Card className="compact-card" style={{ marginTop: 12 }} bordered={false}>
  <Tabs
    activeKey={activeTab}
   onChange={(t) => {
  setActiveTab(t);
  //setClaims([]);        // ✅ CLEAR IMMEDIATELY
  if (selectedSector) {
    fetchClaimsByStatus(selectedSector, t);
  }
}}

  >
    <Tabs.TabPane tab="Unverified" key="UNVERIFIED" />
    <Tabs.TabPane tab="Verified" key="VERIFIED" />
    <Tabs.TabPane tab="Settled" key="SETTLED" />
  </Tabs>

  {/* ✅ ADD BUTTON HERE */}
  {activeTab === "VERIFIED" && (
    <div style={{ marginBottom: 10 }}>
      <Button
        type="primary"
        disabled={selectedRowKeys.length === 0}
        onClick={submitSettlement}
      >
        Submit & Generate Excel
      </Button>
    </div>
  )}
{activeTab === "SETTLED" && (
  <div style={{ marginBottom: 10, display: "flex", gap: 10 }}>
    <Select
      value={settledFilter}
      onChange={setSettledFilter}
      style={{ width: 260 }}
    >
      <Option value="ALL">All</Option>
      <Option value="NO_REVERSAL">No Reversal</Option>
      <Option value="PENDING_REVERSAL">Pending Reversal</Option>
      <Option value="COMPLETED_REVERSAL">Completed Reversal</Option>
    </Select>

    <Button type="primary" onClick={downloadSettledExcel}>
      Download Excel
    </Button>
  </div>
)}


  {loadingClaims ? (
    <div style={{ padding: 24, textAlign: "center" }}>
      <Spin />
    </div>
  ) : (
    <Table
  size="small"
  tableLayout="fixed"
  rowKey="doc_no"
  columns={activeTab === "SETTLED" ? settledColumns : columns}
  dataSource={
    activeTab === "SETTLED" ? filteredSettledClaims : claims
  }
  loading={loadingClaims}   // ✅ THIS IS THE FIX
  pagination={{ pageSize: 10 }}
  rowSelection={
    activeTab === "VERIFIED"
      ? {
          selectedRowKeys,
          onChange: (keys, rows) => {
            setSelectedRowKeys(keys);
            setSelectedRows(rows);
          },
        }
      : null
  }
/>



  )}
</Card>


      {/* MODAL */}
      <Modal
        title={`Claim Details - ${modalRecord?.doc_no || ""}`}
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        width={1200}
        centered
        footer={null}
      >
        {loadingDetails ? (
          <div style={{ padding: 40, textAlign: "center" }}>
            <Spin />
          </div>
        ) : (
          <>
            {/* Scrollable Table */}
            <div
              style={{
                maxHeight: "430px",
                overflowY: "auto",
                paddingRight: 8,
                borderBottom: "1px solid #ddd",
              }}
            >
              <Table
                size="small"
                pagination={false}
                columns={modalColumns}
                dataSource={lineItems}
                scroll={{ x: 1100 }}
              />
            </div>

            {/* Sticky Footer */}
            <div
              style={{
                position: "sticky",
                bottom: 0,
                background: "#fff",
                borderTop: "1px solid #ccc",
                padding: "14px 10px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                zIndex: 50,
              }}
            >
              <div style={{ fontSize: 15, fontWeight: 600 }}>
                Claim Amount: ₹{" "}
                {Number(modalRecord?.CLAIM_AMOUNT || 0).toFixed(2)}
                &nbsp;&nbsp; | &nbsp;&nbsp;
                Total Reversal: ₹ {Number(totalReversal || 0).toFixed(2)}
              </div>

              <div>
                <Button onClick={() => setModalOpen(false)} style={{ marginRight: 8 }}>
                  Close
                </Button>

             {activeTab !== "VERIFIED" && (
  <Button
    type="primary"
    loading={saving}
    onClick={verifyClaim}
  >
    {Number(totalReversal) > 0 ? "VERIFY" : "SETTLE"}
  </Button>
)}


              </div>
            </div>
          </>
        )}
      </Modal>
    </div>
  );
}
